<template>
  <div class="container">
    <div class="row mt-5 mb-5">
      <div class="col-md-6 offset-md-6">
        <h3 class="text-decoration-underline">Lab News</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h4 class="card-title mb-4">Canadian Linguistics Association (June, 2023)</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <img src="news/news1.jpeg" class="float" alt="" width="400" />
        &nbsp; &nbsp; &nbsp; &nbsp;
        <img src="news/news2.jpeg" class="float" alt="" width="400" />
        <!-- &nbsp; &nbsp; &nbsp; &nbsp;
        <img src="news/news2.jpeg" class="float" alt="" width="400" /> -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card-body">
          <p class="card-text fs-5 mb-4">
            Niloufar Ansari and Gabriela Loyola Martinez presenting at the Canadian Linguistics Association (June, 2023)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  border-radius: 35px;
}
</style>  